Alerts = require 'views/lib/alerts'
ApiAjax = require 'network/api-ajax'
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
ArchivableMixin = require 'lib/archivable-mixin'
Auth = require 'db/auth'
Backgrounds = require 'data/backgrounds'
Batcher = require 'network/rpc/batcher'
BoardInvitationList = undefined
queueRequire -> BoardInvitationList = require 'models/collections/board-invitation-list'
BoardPluginList = require 'models/collections/board-plugin-list'
BoardState = require 'view-models/board-state'
CardComposer = require 'view-models/card-composer'
CardFilter = require 'view-models/card-filter'
ChecklistList = undefined
queueRequire -> ChecklistList = require 'models/collections/checklist-list'
Controller = require 'controller'
CustomFieldList = require 'models/collections/custom-field-list'
Hearsay = require 'hearsay'
IdCache = require 'db/id-cache'
Label = require 'models/label'
LabelList = require 'models/collections/label-list'
LegacyPowerUps = require 'data/legacy-power-ups'
LimitMixin = require 'lib/limit-mixin'
ListComposer = require 'view-models/list-composer'
ListList = undefined
queueRequire -> ListList = require 'models/collections/list-list'
MemberList = undefined
queueRequire -> MemberList = require 'models/collections/member-list'
MembershipModel = require 'models/internal/membership-model'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
ModelWithPersonalPreferences = require 'models/internal/model-with-personal-preferences'
Payloads = require 'network/payloads'
PluginDataList = require 'models/collections/plugin-data-list'
Promise = require 'bluebird'
Util = require 'lib/util'
actionFilterFromString = require 'lib/util/action-filter-from-string'
xtend = require 'xtend'
_ = require 'underscore'
mixin = require 'lib/mixin'
moment = require 'moment'
getExperiment = require 'lib/experiments/simple-test'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'
LIST_LIMITS_POWER_UP_ID = require 'data/list-limits-power-up-id'
WELCOME_BOARD_THRESHOLD = 10000

module.exports = class Board extends ModelWithPersonalPreferences
  mixin MembershipModel, ArchivableMixin, LimitMixin, @

  typeName: 'Board'
  urlRoot: '/1/boards'
  initialize: ->
    super

    @listenForPermChange()
    @cacheShortLink()

  @lazy
    boardPluginList: ->
      new BoardPluginList([], { board: @ }).syncCache @modelCache, ['idBoard'], (boardPlugin) =>
        boardPlugin.get('idBoard') == @id
    listList: ->
      new ListList(null, { board: @ })
      .owner(@)
      .syncCache @modelCache, ['idBoard', 'closed'], (list) =>
        list.get('idBoard') == @id && list.isOpen()
    invitationList: ->
      new BoardInvitationList([], { @modelCache, board: @ })
    checklistList: ->
      new ChecklistList([], { @modelCache, board: @ })
    customFieldList: ->
      new CustomFieldList()
      .syncCache @modelCache, ['idModel'], (customField) =>
        customField.get('idModel') == @id
    labelList: ->
      new LabelList()
      .syncCache @modelCache, ['idBoard'], (label) =>
        label.get('idBoard') == @id
    memberList: ->
      new MemberList().syncModel(@, 'memberships', { fxGetIds: (memberships) -> _.pluck(memberships, 'idMember') })
    adminList: ->
      new MemberList().syncModel(@, 'memberships', {
        fxGetIds: (memberships) =>
          # Because a member could be the admin of a premium org (and thus be
          # an implicit admin of this board) but not an admin on the board, we
          # need to also check if the member is a premium org admin.  This check
          # needs to be done directly since getExplicitMemberType may return
          # that the member is an admin due to its board membership info not
          # being updated yet
          adminMemberships = _.filter memberships, (membership) =>
            member = @modelCache.get('Member', membership.idMember)
            return membership.memberType == 'admin' || (member? && @getOrganization()?.isPremOrgAdmin(member))

          _.pluck(adminMemberships, 'idMember')
      })
    pluginDataList: ->
      new PluginDataList([], {
        scopeModel: @
      }).syncCache @modelCache, [], (pluginData) =>
        pluginData.get('idModel') == @id && pluginData.get('scope') == 'board'
    filter: ->
      new CardFilter(@, { @modelCache })
    composer: ->
      new CardComposer(null, { board: @, @modelCache })
    listComposer: ->
      new ListComposer(@, { @modelCache })
    viewState: ->
      new BoardState(null, { @modelCache, board: @ })

  isVisibleAction: (action) ->
    @_actionFilter ?= actionFilterFromString(Payloads.boardActions)
    @_actionFilter(action)

  cacheShortLink: ->
    @waitForAttrs @, ['id', 'shortLink'], ({ id, shortLink }) ->
      IdCache.setBoardId(shortLink, id)

  hasCapacity: (item) ->
    if item.getList?
      # Card
      list = item.getList()
      !@isOverLimit('cards', 'totalPerBoard') &&
      !@isOverLimit('cards', 'openPerBoard')
    else
      # List
      !@isOverLimit('lists', 'totalPerBoard') &&
      !@isOverLimit('lists', 'openPerBoard')

  close: ->
    @update({ closed: true })

    # Optimistically attempt to update free board limit
    @getOrganization()?.incrementFreeBoardLimitCount(-1)

    return

  reopen: ({ newBillableGuests, keepBillableGuests } = {}) ->
    newBillableGuests ?= []
    keepBillableGuests ?= false

    # If we are keeping billable guests upon re-opening, invoke the attribute
    # specific endpoint with the keepBillableGuests param to let server know not to drop
    # them
    if keepBillableGuests
      @set 'closed', false
      @api {
        type: 'put'
        method: "closed?value=false&keepBillableGuests=true"
      }
      return

    # Otherwise, if necessary, optimistically remove any billable guests
    if newBillableGuests.length > 0
      @set 'memberships', _.reject(
        @get('memberships'),
        (membership) -> _.some(newBillableGuests, (guest) -> membership.idMember == guest.id)
      )

    @update({ closed: false })

    # Optimistically attempt to update free board limit
    @getOrganization()?.incrementFreeBoardLimitCount(1)

    return

  markAsViewed: ->
    if !Auth.isLoggedIn()
      return
    @set 'dateLastView', new Date().toISOString()
    ApiAjax
      url: "#{@urlRoot}/#{@id}/markAsViewed"
      type: 'post'
      background: true

  subscribe: (subscribed, next) ->
    return if subscribed == @get('subscribed')
    @update { subscribed }, next

    return

  isStarred: ->
    Auth.me().boardStarList.getBoardStar(@id)?

  hasUnseenActivity: ->
    dtView = @get('dateLastView')
    dtActivity = @get('dateLastActivity')
    dtView? && dtActivity? && dtView < dtActivity

  daysUntilPluginsDisable: ->
    if (date = @get('datePluginDisable'))?
      moment(date).diff(moment(), 'days')
    else
      null

  isLessActive: ->
    dtLastActivity = @get('dateLastActivity') ? new Date(Util.idToDate(@id))
    sixMonthsAgo = moment().subtract(6, 'months')
    sixMonthsAgo.isAfter(dtLastActivity)

  getAvailableRoles: ->
    if @hasObservers()
      ['admin', 'normal', 'observer']
    else
      ['admin', 'normal']

  hasObservers: ->
    @getOrganization()?.isFeatureEnabled("observers")

  getPermLevel: -> @getPref('permissionLevel')

  _normalizePref: (pref) ->
    if pref == 'none'
      'disabled'
    else
      pref

  getCommentPerm: ->
    @_normalizePref @get('prefs').comments

  getInvitePerm: ->
    @_normalizePref @get('prefs').invitations

  toJSON: (opts = {}) ->
    data = super

    if opts.org
      organization = @getOrganization()
      if organization?
        data.hasOrg = true
        data.org = organization.toJSON({ url: true })

    if opts.url
      data.url ?= Controller.getBoardUrl(@)

    if opts.shortUrl
      data.shortUrl ?= Controller.getBoardShortUrl(@)

    data

  calcPos: (index, list) ->
    Util.calcPos(index, @listList, list, (list) -> list.isOpen())

  getCard: (idCard) ->
    if Util.isShortId(idCard)
      @modelCache.findOne('Card', 'idShort', Number(idCard))
    else
      @modelCache.get('Card', idCard)

  getList: (idList) -> @listList.get(idList)

  getUrl: -> Controller.getBoardUrl(@)

  getChecklist: (idChecklist) -> @modelCache.get('Checklist', idChecklist)

  getBoardInvitation: (idBoardInvitation) -> @invitationList.get(idBoardInvitation)

  getCheckItem: (idCheckItem) ->
    for checklist in @checklistList.models
      checkItem = checklist?.checkItemList?.get(idCheckItem)
      if (checkItem)
        return checkItem

  editable: ->
    me = Auth.me()
    me && (@editableByMember(me) || @showBoardAsEditable())

  showBoardAsEditable: ->
    if !getExperiment('teamBoardContribution').get('enabled')
      return false

    org = @getOrganization()
    if !org?
      return false

    me = Auth.me()

    if @isObserver(me)
      return false

    isOrgMember = org.isMember(me)
    return @isPremOrgAdmin(me) || (@allowsSelfJoin() && isOrgMember)

  requestJoinBoard: (callback) ->
    if @shouldRequestJoinBoard()
      @joinBoard(callback)
      Alerts.show('woohoo-you-are-now-a-member-of-this-board', 'info', 'join-board', 4000)
    else
      callback()

  shouldRequestJoinBoard: ->
    @showBoardAsEditable() && !@getMembershipFor(Auth.me())?

  editableByMember: (member) -> @isMember(member)

  isMember: (member) ->
    @getMemberType(member) in ['virtual', 'normal', 'admin']

  getMembershipCount: ->
    @get('membershipCounts')?.active ? @get('memberships')?.length ? 1

  getStarCount: (type) ->
    @get('starCounts')?[type] ? 0

  getIdTags: ->
    @get('idTags') ? []

  owned: ->
    me = Auth.me()
    me && @ownedByMember(me)

  ownedByMember: (member) ->
    @getMemberType(member) == 'admin'

  allowsSelfJoin: ->
    @getPref('selfJoin') ? false

  canDelete: ->
    org = @getOrganization()
    @owned() && (!org || org.canDeleteBoard(@))

  canJoin: ->
    org = @getOrganization()
    if !org?
      return false

    me = Auth.me()

    # We check for the existence of a membership; the might have a
    # memberType of admin due to being a BC admin
    if @getMembershipFor(me)? || @isObserver(me)
      return false

    isOrgMember = org.isMember(me)
    return @isPremOrgAdmin(me) || (@allowsSelfJoin() && isOrgMember)

  canInviteMembers: ->
    if !@getOrganization()? && !@getPref('canInvite')
      return false

    if @get('prefs')?.invitations == 'admins'
      typeAllowedtoInvite = 'admin'

    else if @get('prefs')?.invitations == 'members'
      typeAllowedtoInvite = 'normal'

    @getMemberType(Auth.me()) == 'admin' || typeAllowedtoInvite == @getMemberType(Auth.me())

  canUpsellToEnterprise: ->
    me = Auth.me()

    !me.isDismissed('enterprise-upsell-board-sidebar') &&
    me.enterpriseList?.length == 0 &&
    @hasOrganization() &&
    !@hasEnterprise() &&
    @getOrganization()?.get('memberships').length >= 20

  compareMemberType: (memberA, memberB, opts) ->
    Util.compareMemberType(@, memberA, memberB, opts)

  isMemberPublic: (member) ->
    @getMemberType(member) == 'public'

  isMemberOrg: (member) ->
    @getMemberType(member) == 'org'

  isMemberObserver: (member) ->
    @getMemberType(member) == 'observer'

  memberMatchesSetting: (member, setting) ->
    switch @getPref(setting)
      when 'public'
        Auth.isLoggedIn()
      when 'org'
        @isMember(member) || @isMemberOrg(member) || @isMemberObserver(member)
      when 'observers'
        @isMember(member) || @isMemberObserver(member)
      when 'members'
        @isMember(member)
      when 'admins'
        @ownedByMember(member)
      else # 'none'
        false

  isPowerUpEnabled: (name) ->
    # in some cases we don't *know* about a board's power ups, because we've
    # loaded it (for example) on the "my cards" page, and we want to keep
    # data down to minimum. But we also don't want to pretend like it's empty,
    # since that could be weirder, so we just don't have that field at all.
    # This means that we don't actually *know* if this power up is enabled, so
    # we default to false when we don't have enough information to answer.
    powerUps = @get('powerUps')
    powerUps? && name in powerUps \
        || (name == 'calendar' && LegacyPowerUps.calendar in @idPluginsEnabled()) \
        || (name == 'cardAging' && LegacyPowerUps.cardAging) in @idPluginsEnabled() \
        || (name == 'voting' && LegacyPowerUps.voting) in @idPluginsEnabled()


  powerUpsCount: ->
    # Things in the powerUps list are granfathered and
    # don't count against the limit
    @boardPluginList.length

  canEnableAdditionalPowerUps: ->
    Auth.isLoggedIn() && @powerUpsCount() < Auth.me().getPowerUpsLimit()

  isPluginEnabled: (idPlugin) ->
    @boardPluginList.any (boardPlugin) -> boardPlugin.get('idPlugin') == idPlugin

  isCustomFieldsEnabled: ->
    @isPluginEnabled(CUSTOM_FIELDS_ID)

  isListLimitsPowerUpEnabled: ->
    @isPluginEnabled(LIST_LIMITS_POWER_UP_ID)

  enablePlugin: (idPlugin) ->
    new Promise (resolve) =>
      @boardPluginList.create { idPlugin }, { success: resolve }

  disablePlugin: (idPlugin) ->
    boardPlugin = @boardPluginList.find (boardPlugin) -> boardPlugin.get('idPlugin') == idPlugin
    boardPlugin.destroy()

  # Since voting is a powerUp, it must be enabled and memberMatchesSetting
  canVote: (member) ->
    @memberMatchesSetting(member, 'voting')
  # TODO: TMON-1064 Remove when experiment finishes
  canComment: (member) -> @memberMatchesSetting(member, 'comments') || (@showBoardAsEditable() && @getPref('comments') != 'disabled')
  canInvite: (member) -> @memberMatchesSetting(member, 'invitations')

  prefNames: ['permissionLevel', 'voting', 'comments', 'invitations', 'selfJoin', 'background', 'cardAging', 'calendarFeedEnabled']
  myPrefNames: ['showSidebar', 'showSidebarMembers', 'showSidebarBoardActions', 'showSidebarActivity', 'emailKey', 'idEmailList', 'emailPosition', 'calendarKey', 'fullEmail']

  isPublic: -> @getPref('permissionLevel') == 'public'
  isPrivate: -> @getPref('permissionLevel') == 'private'

  getIdBoardMems: -> _.map(@memberList.models, (member) => member.id )

  getOrganization: ->
    @modelCache.get('Organization', @get('idOrganization'))

  getEnterprise: ->
    @getOrganization()?.getEnterprise()

  # We can't necessarily see the org
  hasOrganization: ->
    @get('idOrganization')

  hasEnterprise: ->
    @getOrganization()?.get('idEnterprise')?

  isOrgAtOrOverFreeBoardLimit: ->
    @getOrganization()?.isAtOrOverFreeBoardLimit() || false

  snoopOrganization: ->
    @snoop('idOrganization').map => @getOrganization()

  orgMembersAvailable: ->
    organization = @getOrganization()
    _.chain organization.memberList.filter (member) =>
      !organization.isDeactivated(member)
    .difference @memberList.models
    .value()

  joinBoard: (next) ->
    me = Auth.me()
    isPremOrgAdmin = @isPremOrgAdmin(me)
    memberType = if isPremOrgAdmin then 'admin' else 'normal'

    # Fake out idBoards/idPremOrgsAdmin client-side, so we don't have to
    # wait for the response back from the server
    me.set('idBoards', me.get('idBoards').concat(@id))
    if isPremOrgAdmin
      me.set('idPremOrgsAdmin', (me.get('idPremOrgsAdmin') ? []).concat(@id))

    @addMember me, memberType, next

  addMember: (member, [memberType, invitationMessage]..., next) ->
    memberType ?= 'normal'

    @memberList.add(member)
    @api {
      type: 'put'
      method: "members/#{ member.id }"
      data: {
        type: memberType,
        invitationMessage: invitationMessage
        allowBillableGuest: true
      }
    }, next

    @set('memberships', @get('memberships').concat({ idMember: member.id, memberType: 'normal' }))

  removeMember: (member) ->
    @memberList.remove(member)
    @set 'memberships', _.reject(@get('memberships'), (membership) -> membership.idMember == member.id)

  getObserverList: -> member for member in @memberList.models when @isObserver(member)

  filterLabels: (term) ->
    termRe = ///^#{Util.escapeForRegex(term)}///

    filteredLabels = []

    _.chain(@getLabels())
      .filter (label) ->
          label.get('name')?.toLowerCase().indexOf(term) > -1 ||
          label.get('color')?.toLowerCase().indexOf(term) == 0 ||
          label.get('color') == Label.colors[parseInt(term) - 1]
      .value()

  labelForColor: (color) ->
    _.chain(@getLabels())
      .filter (label) -> label.get('color') == color
      .first()
      .value()

  labelsForColors: ->
    _.chain(@getLabels())
      .groupBy (label) -> label.get('color')
      .value()

  createLabel: (name, color) ->
    label = _.find @getLabels(), (label) ->
      label.get('name') == name && label.get('color') == color
    if !label
      createdLabel = @labelList.create(
        { name, color: color ? '' }
        {
          url: "/1/board/#{@id}/labels/",
          error: =>
            # The label is optimisitically added.
            # If the add fails, remove the label
            @labelList.remove(createdLabel)
        }
      )
    return

  labelColors: -> Label.colors

  getLabels: ->
    @labelList.models.sort(Label.compare)

  _generateKey: (type) ->
    @api
      type: 'post'
      method: "#{type}Key/generate"

  generateEmailKey: ->
    @_generateKey 'email'

  generateCalendarKey: ->
    @_generateKey 'calendar'

  openCards: ->
    _.flatten(list.openCards().models for list in @listList.models)

  listenForPermChange: ->
    if !Auth.isLoggedIn()
      return # nothing to listen for

    lastPermState = @getViewPermState(Auth.me())
    lastOwned = @owned()

    checkChange = @debounce =>
      currentPermState = @getViewPermState(Auth.me())
      if currentPermState != lastPermState
        lastPermState = currentPermState
        @trigger('permChange', currentPermState)

      currentOwned = @owned()
      if currentOwned != lastOwned
        lastOwned = currentOwned
        @trigger('ownedChange', currentOwned)
      return

    @listenTo Auth.me().boardList, 'add remove reset', checkChange
    @listenTo Auth.me().organizationList, 'add remove reset', checkChange
    @listenTo @memberList, 'add remove reset', checkChange
    @listenTo @, 'change:memberships change:prefs.permissionLevel', checkChange

  getViewPermState: (member) ->
    if @isObserver(member)
      'observer'
    else if @getMemberType(member) in ['normal', 'admin']
      'member'
    else if Util.hasValidInviteTokenFor(@)
      'inviteToken'
    else if @getOrganization()?.isMember(member) && @getPref('permissionLevel') == 'org'
      'org'
    else if @getPref('permissionLevel') == 'public'
      'public'
    else if @getEnterprise()?.canViewEnterpriseVisibleBoard(member) && @getPref('permissionLevel') == 'enterprise'
      'enterprise'
    else
      'none'

  getClientBackgroundColor: (background) ->
    Backgrounds[background]?.color ? Backgrounds['blue'].color

  dataForLabel: (label) ->
    label.toJSON()

  isViewableBy: (member) ->
    @getViewPermState(member) != 'none'

  toggleTag: (idTag) ->
    @toggle('idTags', idTag, idTag !in @getIdTags())

  setPluginData: (idPlugin, visibility, data) ->
    @pluginDataList.upsert(idPlugin, visibility, data)

  getPluginData: (idPlugin) ->
    xtend @getOrganization()?.getPluginData(idPlugin), @pluginDataList.dataForPlugin(idPlugin)

  snoopPluginData: (idPlugin) ->
    orgPluginData = @snoopOrganization()
    .map (org) ->
      if org?
        org.snoopPluginData(idPlugin)
      else
        Hearsay.const null
    .latest()

    boardPluginData = @pluginDataList.snoopDataForPlugin(idPlugin)

    Hearsay.combine orgPluginData, boardPluginData
    .map (entries) -> xtend entries...

  clearPluginData: (idPlugin) ->
    boardData = @pluginDataList.for(idPlugin, 'private')
    if boardData?
      boardData.destroy()
    orgData = @getOrganization()?.pluginDataList.for(idPlugin, 'private')
    if orgData?
      orgData.destroy()

  idPluginsEnabled: ->
    @boardPluginList.pluck('idPlugin')

  snoopIdPluginsEnabled: ->
    Hearsay.combine(@boardPluginList.snoop())
    .map ([boardPluginList]) ->
      boardPluginList.pluck('idPlugin')

  invitationUrl: (secret) ->
    Controller.getBoardInvitionLinkUrl(secret)

  startDelete: ->
    @_isDeleting = true
    @trigger 'deleting'

    # This *starts* the delete, but it may take a while for it to actually
    # be deleted
    ApiPromise
      method: 'delete'
      url: @url()
    .then =>
      new Promise (resolve) =>
        checkBoard = =>
          ApiPromise
            url: @url()
            fields: ''
          .then =>
            setTimeout checkBoard, 500
          .catch ApiError.NotFound, =>
            resolve()
          .done()

        checkBoard()
    .then =>
      @modelCache.remove(@)
    .return()

  isDeleting: ->
    @_isDeleting

  isOrgBoard: ->
    # We consider it to be an org board if it belongs to an organization that
    # the member is part of
    idOrg = @getOrganization()?.id
    idOrg? && idOrg in Auth.me().get('idOrganizations')

  isEnterpriseBoard: ->
    # We consider it to be an enterprise board if it belongs to an organization
    # that belongs to an enterprise. We also check if it's a real enterprise,
    # because we still have BCPO teams in the enterprises collection :/
    @getOrganization()?.isEnterprise() && @getOrganization()?.belongsToRealEnterprise()

  isWelcomeBoard: ->
    # creationMethod will always be demo for welcome boards
    # NOTE: we still use the old logic w/ threshold bc older welcome boards
    # don't have the creationMethod set
    @get('creationMethod') == 'demo' ||
      0 <= Util.idToDate(@get('id')) - Util.idToDate(Auth.myId()) < WELCOME_BOARD_THRESHOLD

  isFirstOwnedBoard: ->
    # Use a tighter threshold for boards created shortly after account creation,
    # including the skipBoardsPage board
    welcomeBoardThreshold = 1000
    # This is not quite the same as the check done in create board component
    # or view, but should be good enough for new users without waiting on
    # Auth.me().boardList being completely loaded since we have all the idBoards
    # that a member is on, including the current board.
    me = Auth.me()
    idBoards = me.get('idBoards')
    nonInvitedOrWelcomeBoardIds = _.filter idBoards, (idBoard) ->
    # Boards created after member was created
      !me.accountNewerThan(Util.idToDate(idBoard)) &&
        # Non-welcome boards
        Util.idToDate(idBoard) - Util.idToDate(Auth.myId()) > welcomeBoardThreshold
    nonInvitedOrWelcomeBoardIds.length == 1

  loadPlugins: ->
    @availablePlugins = ModelLoader.loadBoardPlugins(@id)

  getAvailablePlugins: ->
    @availablePlugins ?= @loadPlugins()

  hasCustomField: (type, name) ->
    @customFieldList.some (cf) ->
      cf.get('type') == type &&
      cf.get('name') == name

  getAttachmentRestrictions: ->
    @getOrganization()?.getPref('attachmentRestrictions')

  attachmentTypeRestricted: (attachmentType) ->
    @getOrganization()?.attachmentTypeRestricted(attachmentType)

  attachmentUrlRestricted: (url) ->
    @getOrganization()?.attachmentUrlRestricted(url)

  canRemoveMember: (member) ->
    @getMembershipFor(member) && (!@ownedByMember(member) || (@ownedByMember(member) && @adminList.length > 1))

  getNewBillableGuests: ->
    if !Auth.isLoggedIn()
      return Promise.resolve([])

    org = @getOrganization()
    if org?.isPO() && org?.isBusinessClass()
      response = {}
      batcher = new Batcher()
      [
        "/1/organizations/#{org.id}/newBillableGuests/#{@id}"
        "/1/organizations/#{org.id}?fields=availableLicenseCount"
      ].map (url) ->
        batcher.request(url)
        .then (res) ->
          if !response.newBillableGuests
            response.newBillableGuests = res
          else
            response.availableLicenseCount = if res.availableLicenseCount == null
                Infinity
              else
                res.availableLicenseCount
          Promise.resolve(response)
        .error ->
          Promise.resolve([])
      batcher.send().then ->
        response
    else
      hasBillableGuestsFeature = org?.isFeatureEnabled('multiBoardGuests')

      if hasBillableGuestsFeature
        ApiPromise
          url: "/1/organizations/#{org.id}/newBillableGuests/#{@id}"
          type: 'get'
          background: true
        .then (response) ->
          newBillableGuests: response
          availableLicenseCount: Infinity
      else
        Promise.resolve
          newBillableGuests: []
          availableLicenseCount: Infinity



// WEBPACK FOOTER //
// ./app/scripts/models/board.coffee